<template>
    <v-container fill>
        <!-- // ** search -->
        <div>
            <v-row no-gutters>
                <v-col :cols="getSearchFieldCols">
                    <v-text-field-filled
                        v-model="search"
                        placeholder="Rechercher"
                        :label="searchLabel"
                        clearable
                        append-inner-icon="$search"
                        @click:clear="search = ''"
                        :autofocus="true"
                        data-cy="companiesTable-search"
                        id="CompanyTable_search-field"
                        @keydown.tab="focusOnFirstSupplier"
                    />
                </v-col>
                <v-col cols="2" class="pl-2 align-center" v-if="showImport">
                    <v-btn variant="tonal" block @click="importCompanies"> Importer </v-btn>
                </v-col>
            </v-row>
            <!-- <v-flex xs2 class="pl-4 pb-4 align-center">
                <v-switch
                    v-model="doublon"
                    label="Doublons"
                    @click:append="doublon = true"
                    color="primary"
                    dense
                    inset
                >
                </v-switch> -->
            <!-- </v-col>
                    </v-row> -->
            <!-- <v-flex xs2 class="pl-4"> -->
            <!-- <v-btn
                    v-if="selectedCompanies.length > 1"
                    :label="selectedCompanies"
                    dense
                    color="secondary"
                    class="rounded-lg gradient"
                    inset
                    @click="companiesToMerge()"
                >Fusionner
                </v-btn> -->
            <!-- </v-col>
                    </v-row> -->
        </div>
        <div>
            <v-row no-gutters>
                <v-col :cols="getTabsCols">
                    <v-tabs v-model="activeTab" class="tab_budget_form_mobile">
                        <v-tab
                            v-for="tab in availableTabs"
                            :key="tab.value"
                            :value="tab.value"
                            :data-cy="tab.dataCy"
                            ripple
                            @click="tab.hasClick ? emptyMergingList() : null"
                        >
                            {{ tab.label }}
                        </v-tab>
                    </v-tabs>
                </v-col>
                <v-col
                    cols="1"
                    class="pl-2 align-center text-right"
                    v-if="activeTab !== 'showGenericCompany'"
                >
                    <!-- Icon to show/hide inactive companies -->
                    <v-btn-icon
                        :icon="inactiveCompaniesIcon"
                        @click.stop="toggleShowInactive"
                        v-tooltip:left="inactiveCompaniesTooltip"
                    />
                </v-col>
            </v-row>
            <v-tabs-window v-model="activeTab">
                <!-- generic companies -->
                <v-window-item v-if="showGenericCompany" value="showGenericCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                            >
                                <v-list-item
                                    v-for="company in genericCompanies"
                                    :key="company.id"
                                    @click.stop="onAdd(company)"
                                    class="my-1"
                                    :data-cy="'CompaniesTable-name-' + company.id"
                                    lines="one"
                                    border
                                    rounded="xl"
                                >
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <template #append class="my-0">
                                        <v-btn-next tabindex="-1" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="loadingGenericDb"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- consumer companies -->
                <v-window-item
                    v-if="showConsumerCompany && consumerCompany"
                    key="showConsumerCompany"
                    value="showConsumerCompany"
                >
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                            >
                                <v-list-item
                                    @click.stop="onAdd(consumerCompany)"
                                    class="my-1"
                                    lines="one"
                                    border
                                    rounded="xl"
                                >
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        Particulier
                                    </v-list-item-title>
                                    <!-- <v-list-item-subtitle>{{ getSiretValue(company.siret) }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div> -->
                                    <template #append class="my-0">
                                        <v-btn-icon icon="$fa-star"> </v-btn-icon>
                                        <v-btn-next />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="loadingConsumerDb"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- customer companies -->
                <v-window-item
                    v-if="showCustomerCompanies"
                    key="showCustomerCompany"
                    value="showCustomerCompany"
                >
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-col cols="12" class="mb-2 d-flex align-center justify-center">
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    elevation="0"
                                    class="mr-2"
                                    rounded="xl"
                                    @click="selectAllCompany(customerCompanies)"
                                    data-cy="UserEdition-allCompanies"
                                    size="small"
                                >
                                    Sélectionner toutes les sociétés
                                </v-btn>
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    rounded="xl"
                                    elevation="0"
                                    @click="diselectAllCompany()"
                                    data-cy="UserEdition-notAllCompanies"
                                    size="small"
                                >
                                    Désélectionner toutes les sociétés
                                </v-btn>
                            </v-col>
                            <v-list v-model="selectedCompanies" multiple>
                                <v-virtual-scroll
                                    :items="customerCompanies"
                                    :item-height="65"
                                    height="500"
                                >
                                    <template v-slot="{ item: company }">
                                        <v-list-item
                                            :key="company.id"
                                            :value="company.id"
                                            class="my-1"
                                            data-cy="companiesTable-customerCompany"
                                            lines="one"
                                            border
                                            rounded="xl"
                                            @click.stop="onAdd(company)"
                                        >
                                            <template #prepend class="my-0">
                                                <v-checkbox
                                                    v-model="selectedCompanies"
                                                    v-if="showSelectMergeCompanies"
                                                    @click.stop="companiesToMerge(company.id)"
                                                    :value="isSelectedCompany(company.id)"
                                                >
                                                </v-checkbox>
                                            </template>
                                            <v-list-item-title
                                                style="text-overflow: ellipsis; max-width: 500px"
                                            >
                                                {{ getFullCompanyName(company) }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                getSiretValue(company.siret)
                                            }}</v-list-item-subtitle>
                                            <div class="body-2">
                                                {{ company.address }} {{ company.city }}
                                            </div>
                                            <template #append class="my-0">
                                                <v-btn-icon
                                                    color="primary"
                                                    icon="$fa-star"
                                                    v-if="isFavOf(company.thirdPartyCompanyData)"
                                                    @click.stop="addToFav(company)"
                                                />
                                                <v-btn-icon
                                                    icon="$far-fa-star"
                                                    v-else
                                                    @click.stop="addToFav(company)"
                                                />
                                                <v-btn-next
                                                    tabindex="-1"
                                                    @click.stop="onAdd(company)"
                                                />
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                            <!-- <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                                select-strategy="leaf"
                                v-model:selected="selectedCompanies"
                            >
                                <v-list-item
                                    v-for="company in customerCompanies"
                                    :key="company.id"
                                    :value="company.id"
                                    class="my-1"
                                    data-cy="companiesTable-customerCompany"
                                    lines="one"
                                    border
                                    rounded="xl"
                                    @click.stop="onAdd(company)"
                                >
                                    <template
                                        #prepend="{ isSelected }"
                                        class="my-0"
                                        v-if="showSelectMergeCompanies"
                                    >
                                        <v-checkbox
                                            :model-value="isSelected"
                                            @click.stop="() => {}"
                                        ></v-checkbox>
                                    </template>
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 500px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <template #append class="my-0">
                                        <v-btn-icon
                                            icon="$fa-star"
                                            v-if="isFavOf(company.thirdPartyCompanyData)"
                                            @click="addToFav(company)"
                                        />
                                        <v-btn-icon
                                            icon="$fa-star"
                                            v-else
                                            @click="addToFav(company)"
                                        />
                                        <v-btn-next tabindex="-1" @click.stop="onAdd(company)" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="customerCompaniesLoading"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list> -->
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- supplier companies -->
                <v-window-item v-if="showSupplierCompanies" value="showSupplierCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-col cols="12" class="mb-2 d-flex align-center justify-center">
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    elevation="0"
                                    class="mr-2"
                                    rounded="xl"
                                    @click.stop="selectAllCompany(supplierCompanies)"
                                    data-cy="UserEdition-allCompanies"
                                    size="small"
                                >
                                    Sélectionner toutes les sociétés
                                </v-btn>
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    elevation="0"
                                    rounded="xl"
                                    @click.stop="diselectAllCompany()"
                                    data-cy="UserEdition-notAllCompanies"
                                    size="small"
                                >
                                    Désélectionner toutes les sociétés
                                </v-btn>
                            </v-col>
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                            >
                                <v-list-item
                                    v-for="company in filteredSupplierCompanies"
                                    :key="company.id"
                                    class="my-1"
                                    @click.stop="onAdd(company)"
                                    :data-cy="`CompaniesTable-${company.id}`"
                                    border
                                    lines="one"
                                    rounded="xl"
                                >
                                    <template #prepend class="my-0">
                                        <v-checkbox
                                            v-model="selectedCompanies"
                                            v-if="showSelectMergeCompanies"
                                            @click.stop="companiesToMerge(company.id)"
                                            :value="isSelectedCompany(company.id)"
                                        >
                                        </v-checkbox>
                                    </template>
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <template #append class="my-0 d-flex flex-row align-center">
                                        <v-btn-icon
                                            icon="$fa-star"
                                            v-if="
                                                company.thirdPartyCompanyData &&
                                                (company.thirdPartyCompanyData as any)?.isFavorite
                                            "
                                        />
                                        <v-btn-icon icon="$fa-star" v-else />
                                        <v-btn-next tabindex="-1" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="supplierCompaniesLoading"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- bobbee companies -->
                <v-window-item v-if="showBobbeeCompanies" value="showBobbeeCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-col cols="12" class="mb-2 d-flex align-center justify-center">
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    dark
                                    elevation="0"
                                    class="mr-2"
                                    rounded="xl"
                                    size="small"
                                    @click.stop="selectAllCompany(bobbeeCompanies)"
                                    data-cy="UserEdition-allCompanies"
                                >
                                    Sélectionner toutes les sociétés
                                </v-btn>
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    dark
                                    elevation="0"
                                    rounded="xl"
                                    size="small"
                                    @click.stop="diselectAllCompany()"
                                    data-cy="UserEdition-notAllCompanies"
                                >
                                    Désélectionner toutes les sociétés
                                </v-btn>
                            </v-col>
                            <v-list
                                two-line
                                subheader
                                :style="
                                    $vuetify.display.xs
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                            >
                                <v-list-item
                                    v-for="company in filteredBobbeeCompanies"
                                    :key="company.id"
                                    class="my-1"
                                    @click.stop="onAdd(company)"
                                    :data-cy="`CompaniesTable-${company.id}`"
                                    border
                                    rounded="xl"
                                >
                                    <template #prepend class="my-0">
                                        <v-checkbox
                                            v-model="selectedCompanies"
                                            :value="isSelectedCompany(company.id)"
                                            v-if="showSelectMergeCompanies"
                                            color="primary"
                                            @click.stop="companiesToMerge(company.id)"
                                        >
                                        </v-checkbox>
                                    </template>
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <template #append class="my-0">
                                        <v-btn-next tabindex="-1" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="bobbeeCompaniesLoading"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-window-item>
                <!-- orphelin companies -->
                <v-window-item v-if="showOrphelinCompanies" value="showOrphelinCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-col cols="12" class="mb-2 d-flex align-center justify-center">
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    elevation="0"
                                    class="mr-2"
                                    rounded="xl"
                                    @click.stop="selectAllCompany(orphelinCompanies)"
                                    data-cy="UserEdition-allCompanies"
                                    size="small"
                                >
                                    Sélectionner toutes les sociétés
                                </v-btn>
                                <v-btn
                                    v-if="showSelectMergeCompanies"
                                    elevation="0"
                                    rounded="xl"
                                    @click.stop="diselectAllCompany()"
                                    data-cy="UserEdition-notAllCompanies"
                                    size="small"
                                >
                                    Désélectionner toutes les sociétés
                                </v-btn>
                            </v-col>
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                                lines="one"
                            >
                                <v-list-item
                                    v-for="company in filteredOrphelinCompanies"
                                    :key="company.id"
                                    class="my-1"
                                    @click.stop="onAdd(company)"
                                    border
                                    rounded="xl"
                                >
                                    <template #prepend class="my-0">
                                        <v-checkbox
                                            v-model="selectedCompanies"
                                            :value="isSelectedCompany(company.id)"
                                            v-if="showSelectMergeCompanies"
                                            color="primary"
                                            @click.stop="companiesToMerge(company.id)"
                                        >
                                        </v-checkbox>
                                        <!-- <v-checkbox
                                            v-model="selectedCompanies"
                                            :value="company.id"
                                            :key="i +company.id"
                                            color="primary"
                                            v-if="showSelectMergeCompanies"
                                            @click.stop="()=>{}"
                                        >
                                        </v-checkbox> -->
                                    </template>
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <template #append class="my-0" style="background: #fff">
                                        <v-btn-trash
                                            v-model="company.id"
                                            @click.stop="confirmToDeleteOrphelin(company)"
                                        />
                                    </template>
                                    <!-- <template v-slot:append class="my-0">
                                        <v-btn icon>
                                            <v-icon color="primary">$chevron_right</v-icon>
                                        </v-btn>
                                    </template> -->
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-if="orphelinCompaniesLoading"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- exisiting companies -->
                <v-window-item v-if="showExistingCompanies" value="showExistingCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                                lines="one"
                            >
                                <v-list-item
                                    v-for="company in itemsDb"
                                    :key="company.id"
                                    @click.stop="onAdd(company)"
                                    class="my-1"
                                    :data-cy="'CompaniesTable-' + company.siret"
                                    rounded="xl"
                                    border
                                >
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <template #append class="my-0">
                                        <v-btn-next tabindex="-1" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-intersect="paginationDBIntersecting"
                                    v-if="loadingCompaniesDb || companiesCount_db > items_db.length"
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- found companies -->
                <v-window-item
                    v-if="foundCompanies && foundCompanies.length"
                    value="showFoundCompany"
                >
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            :style="
                                $vuetify.display.mobile
                                    ? 'max-height: 50vh; overflow: auto'
                                    : `max-height: ${listHeight}; overflow: auto`
                            "
                        >
                            <v-list
                                v-for="(metaCompany, index) in foundCompanies"
                                :key="index"
                                subheader
                                lines="one"
                            >
                                <v-list-subheader>{{
                                    metaCompany.rechercheAssociée.join(" ")
                                }}</v-list-subheader>
                                <v-list-item
                                    class="my-1"
                                    v-for="company in filterCompanies(metaCompany.companies)"
                                    :key="company.siret"
                                    @click.stop="
                                        company.isActive !== false ? onAdd(company) : () => {}
                                    "
                                    rounded="xl"
                                    border
                                >
                                    <v-list-item-title>
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <template #append class="my-0">
                                        <v-icon v-if="company.id">$storage</v-icon>
                                        <v-icon v-else-if="company.isActive === false"
                                            >$highlight_off</v-icon
                                        >
                                        <v-icon v-else>$fiber_new</v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
                <!-- new companies -->
                <v-window-item v-if="showNewCompanies" value="showNewCompany">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list
                                subheader
                                :style="
                                    $vuetify.display.mobile
                                        ? 'height: 50vh; overflow: auto'
                                        : `height: ${listHeight}; overflow: auto`
                                "
                                lines="one"
                            >
                                <v-list-item
                                    class="my-1"
                                    v-if="search && search.length"
                                    @click="createNewMissingCompany()"
                                    data-cy="companiesTable-addMissingCompany"
                                    rounded="xl"
                                    border
                                >
                                    <v-list-item-title>
                                        {{ search }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                        >La sociéte n'est pas dans la liste. J'en crée
                                        une</v-list-item-subtitle
                                    >
                                    <template #append class="my-0">
                                        <v-btn-icon
                                            icon="$add"
                                            color="secondary"
                                            dark
                                            size="small"
                                            class="elevation-0"
                                        />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    v-for="company in itemsApi"
                                    :key="company.siret"
                                    @click.stop="isSelectable(company) ? onAdd(company) : () => {}"
                                    rounded="xl"
                                    border
                                >
                                    <v-list-item-title>
                                        {{ getFullCompanyName(company) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        getSiretValue(company.siret)
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="company.archivingDate">{{
                                        "Archivé le : " + getArchivingDate(company.archivingDate)
                                    }}</v-list-item-subtitle>
                                    <div class="body-2">
                                        {{ company.address }} {{ company.city }}
                                    </div>
                                    <p v-if="company.isActive === false" class="text-red">
                                        Cette société n'est plus active
                                    </p>
                                    <p
                                        v-if="
                                            company.isClientOfAccountingFirm &&
                                            !canSelectCompaniesWithAccountingCompany
                                        "
                                        class="text-red"
                                    >
                                        Cette société est déjà présente dans votre liste de
                                        dossiers.
                                    </p>
                                    <p
                                        v-if="company.archivingDate && isCompanyArchived"
                                        class="text-red"
                                    >
                                        Cette société est déjà présente dans votre liste de dossiers
                                        archivés.
                                    </p>
                                    <template #append class="my-0">
                                        <v-icon
                                            v-if="
                                                company.isClientOfAccountingFirm &&
                                                !canSelectCompaniesWithAccountingCompany
                                            "
                                            >$highlight_off</v-icon
                                        >
                                        <v-icon v-else-if="company.id">$storage</v-icon>
                                        <v-icon v-else-if="company.isActive === false"
                                            >$highlight_off</v-icon
                                        >
                                        <v-icon v-else-if="company.archivingDate"
                                            >$highlight_off</v-icon
                                        >
                                        <v-icon v-else>$fiber_new</v-icon>
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-intersect="paginationAPIIntersecting"
                                    v-if="
                                        loadingCompaniesApi ||
                                        loadingArchivedClientCompanies ||
                                        companiesCount_api > items_api.length
                                    "
                                >
                                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                                </v-list-item>
                                <v-list-item
                                    class="my-1"
                                    style="background: #fff"
                                    v-intersect="paginationAPIIntersecting"
                                    v-if="!search || !search.length"
                                >
                                    <v-list-item-title class="py-0">
                                        Faites une recherche de sociétés, les résultats
                                        appara&#xee;tront ici
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <!-- </div> -->
                </v-window-item>
            </v-tabs-window>
        </div>
        <oss-dialog
            v-model="confirmDeleteDialog"
            title="Suppression Société"
            @valid="
                deleteOrphelin(toDeleteCompany.id);
                confirmDeleteDialog = false;
            "
            max-width="40vw"
        >
            <h4>Voulez-vous supprimer la société {{ toDeleteCompany.name }} ?</h4>
        </oss-dialog>
        <oss-dialog
            v-if="multiDeleteDialog"
            v-model="multiDeleteDialog"
            title="Suppression Société"
            @valid="deleteOrphelinCompanies()"
            max-width="40vw"
        >
            <h4>Voulez-vous supprimer {{ selectedCompanies.length }} société(s) ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { getSiretValue } from "../../services/companyServices";

import SAVE_COMPANY_FAV from "@/graphql/company/UpsertThirdPartyCompany.gql";
import GENERIC_COMPANIES from "../../graphql/company/GenericCompanies.gql";
import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import ORPHELIN_COMPANIES from "../../graphql/company/OrphelinCompanies.gql";
import SUPPLIER_COMPANIES from "../../graphql/company/SupplierCompanies.gql";
import BOBBEE_COMPANIES from "../../graphql/company/BobbeeCompanies.gql";
import COMPANIES_FOR_COMPANY_DB from "../../graphql/company/CompaniesForCompany.gql";
import COMPANIES_DB from "../../graphql/company/Companies.gql";
import COMPANIES_API from "../../graphql/company/CompaniesDBAndAPI.gql";
import DB_FOUND_COMPANIES from "../../graphql/company/dbFoundCompanies.gql";
import DELETE_COMPANY from "../../graphql/company/DeleteCompany.gql";
import DELETE_ORPHELIN_COMPANIES from "../../graphql/company/DeleteOrphelinCompanies.gql";
import GET_ARCHIVED_COMPANIES from "../../graphql/company/GetArchivingCompanyClientCompanies.gql";
import { Component, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Company } from "../../../../types/types";
import { CompanyFilterMixin } from "./mixins/CompanyFilterMixin";
import moment from "moment-timezone";

@Component({
    emits: [
        "select-company",
        "companies-to-merge",
        "disable-merge-button",
        "import-companies",
        "emit-actions",
    ],
})
export class CompaniesTable extends CompanyFilterMixin {
    @Prop({ default: false }) showConsumerCompany!: boolean;
    @Prop({ default: true }) showGenericCompany!: boolean;
    @Prop({ default: false }) showCustomerCompanies!: boolean;
    @Prop({ default: false }) showSupplierCompanies!: boolean;
    @Prop({ default: false }) showOrphelinCompanies!: boolean;
    @Prop({ default: true }) showExistingCompanies!: boolean;
    @Prop({ default: false }) showSelectMergeCompanies!: boolean;
    @Prop({ default: false }) showBobbeeCompanies!: boolean;
    @Prop({ default: true }) showNewCompanies!: boolean;
    @Prop({ default: false }) showParentCompany!: boolean;
    @Prop({ default: false }) showImportCompanies!: boolean;
    @Prop({ default: null }) foundCompanies!: any;
    @Prop({ default: false }) editable!: boolean;
    @Prop({ default: "" }) company: string;
    @Prop({ default: "" }) vatNumber: string;
    @Prop({ default: "" }) siret: string;
    @Prop({ default: "" }) siren: string;
    @Prop({ default: "" }) accountingFirmId!: string;
    @Prop({ default: "" }) parentCompanyId!: string;
    @Prop({ default: false }) wizardMode: boolean;
    @Model() value: any;
    @Prop() actions: any;
    @Prop({ default: "40vh" }) listHeight: string;
    @Prop({ default: true }) canSelectCompaniesWithAccountingCompany: boolean;
    @Prop({ default: false }) canSelectInactiveCompanies: boolean;
    @Prop({ default: false }) showImport: boolean;
    @Prop({ default: false }) isEnableAccountingFirms: boolean;

    search: string = "";
    showInactive: boolean = false; // Toggle to show/hide inactive companies

    toDeleteCompany = {
        id: "",
        name: "",
    };

    selectedCompanies = [];

    @Watch("company")
    @Watch("vatNumber")
    @Watch("siret")
    @Watch("siren")
    searchWatch() {
        if (this.siret !== "") {
            this.search = this.siret;
        } else if (this.siren !== "") {
            this.search = this.siren;
        } else if (this.vatNumber !== "") {
            this.search = this.vatNumber;
        } else if (this.company) {
            this.search = this.company;
        } else {
            this.search = "";
        }
    }

    isFavOf(thirdPartyCompanyData: { [key: string]: any }) {
        return thirdPartyCompanyData?.isFavorite;
    }

    async addToFav(company) {
        if (!company?.thirdPartyCompanyData) {
            company.thirdPartyCompanyData = { isFavorite: true };
        } else if (company.thirdPartyCompanyData?.isFavorite) {
            company.thirdPartyCompanyData.isFavorite = false;
        } else {
            company.thirdPartyCompanyData.isFavorite = true;
        }
        const result = await this.$apollo.mutate({
            mutation: SAVE_COMPANY_FAV,
            variables: {
                parentCompanyId: this.parentCompanyId,
                thirdPartyCompanyId: company.id,
                data: JSON.parse(JSON.stringify(company.thirdPartyCompanyData)),
            },
        });
        this.sortCustomers(this.customerCompanies);
    }

    multiDeleteDialog = false;

    activeTab: string = "";

    dicoActiveTabTPCType = {
        showConsumerCompany: "customer",
        showGenericCompany: "supplier",
        showCustomerCompany: "customer",
        showSupplierCompany: "supplier",
        showOrphelinCompany: "unknown",
        showExistingCompany: "unknown",
        showFoundCompany: "unknown",
        showNewCompany: "unknown",
    };

    get availableTabs() {
        return [
            {
                label: "Particulier",
                value: "showConsumerCompany",
                condition: this.showConsumerCompany,
                dataCy: "companiesTable-consumerCompany-tab",
                hasClick: true,
            },
            {
                label: "Sociétés génériques",
                value: "showGenericCompany",
                condition: this.showGenericCompany,
                dataCy: "companiesTable-genericCompany-tab",
                hasClick: true,
            },
            {
                label: "Mes clients",
                value: "showCustomerCompany",
                condition: this.showCustomerCompanies,
                dataCy: "companiesTable-customerCompany-tab",
                hasClick: true,
            },
            {
                label: "Mes fournisseurs",
                value: "showSupplierCompany",
                condition: this.showSupplierCompanies,
                dataCy: "companiesTable-supplierCompany-tab",
                hasClick: true,
            },
            {
                label: "Mes clients bobbee",
                value: "showBobbeeCompany",
                condition: this.showBobbeeCompanies,
                dataCy: "companiesTable-bobbeeCompany-tab",
                hasClick: true,
            },
            {
                label: "Sociétés Orphelines",
                value: "showOrphelinCompany",
                condition: this.showOrphelinCompanies,
                dataCy: "companiesTable-orphelinCompany-tab",
                hasClick: true,
            },
            {
                label: "Sociétés référencées",
                value: "showExistingCompany",
                condition: this.showExistingCompanies,
                dataCy: "companiesTable-existingCompany-tab",
                hasClick: true,
            },
            {
                label: "Sociétés trouvées",
                value: "showFoundCompany",
                condition: this.foundCompanies?.length,
                dataCy: "companiesTable-foundCompany-tab",
                hasClick: true,
            },
            {
                label: "Autres sociétés",
                value: "showNewCompany",
                condition: this.showNewCompanies,
                dataCy: "companiesTable-newCompany-tab",
                hasClick: false,
            },
        ].filter((tab) => tab.condition);
    }

    get infiniteScroll() {
        return this.wizardMode || this.$vuetify.display.mobile;
    }

    isSelected(company) {
        if (this.value) {
            if (Array.isArray(this.value)) {
                return this.value.includes((x) => x.id === company.id || x.siret === company.siret);
            }
            return this.value.id === company.id || this.value.siret === company.siret;
        }
        return false;
    }

    beforeMount() {
        if (!this.activeTab) {
            if (this.showCustomerCompanies) this.activeTab = "showCustomerCompany";
            else if (this.showSupplierCompanies) this.activeTab = "showSupplierCompany";
            else if (this.showExistingCompanies) this.activeTab = "showExistingCompany";
            else if (this.showGenericCompany) this.activeTab = "showGenericCompany";
            else if (this.showBobbeeCompanies) this.activeTab = "showBobbeeCompany";
            else if (this.showConsumerCompany) this.activeTab = "showConsumerCompany";
            else if (this.showOrphelinCompanies) this.activeTab = "showOrphelinCompany";
            else if (this.showNewCompanies) this.activeTab = "showNewCompany";
        }
        this.searchWatch();
        if (this?.actions) {
            this.setActions();
        }

        this.focusOnSearchInput();
    }

    focusOnSearchInput() {
        const searchInput = document.getElementById("CompanyTable_search-field");
        if (searchInput) {
            searchInput.focus();
        }
    }

    get searchLabel() {
        if (this.activeTab === "showGenericCompany") return "Rechercher (Nom de la société)";
        return "Rechercher (SIRET, SIREN, Numero TVA, Nom de la société)";
    }

    /**
     * Dynamically calculates the width of the search field based on
     * the visibility of the "Import" button.
     */
    get getSearchFieldCols() {
        return this.showImport ? 10 : 12;
    }

    get getTabsCols() {
        return this.activeTab !== "showGenericCompany" ? 11 : 12;
    }

    /**
     * Method that filters active/inactive companies based on `showInactive`
     * it's specific to foundCompanies
     */
    filterCompanies(companies: Array<Company>) {
        if (!companies) return [];

        const activeCompanies = companies.filter((company) => company.isActive !== false);
        if (activeCompanies.length <= 5) {
            return companies;
        }

        return this.showInactive ? companies : activeCompanies;
    }

    // get fatherlessLabel(){
    //     if(this.activeTab === "showSupplierCompany" || this.activeTab === "showCustomerCompany")
    //         return true
    // }

    get headers_db() {
        const headers = [
            { text: "Nom de la société", value: "name", align: "left", sortable: false },
            { text: "Siret", value: "siret", sortable: false },
            { text: "Siren", value: "siren", sortable: false },
            { text: "Adresse", value: "address", sortable: false },
            { text: "Code postal", value: "address", sortable: false },
        ];
        if (this.editable) {
            headers.push({ text: "Edit", value: "edit", sortable: false });
        }
        if (this.showParentCompany) {
            headers.push({ text: "Société parente", value: "parentCompanyName", sortable: false });
        }
        return headers;
    }

    get headersGenerics() {
        const headers = [
            { text: "Nom de la société", value: "name", align: "left", sortable: false },
            { text: "Activité", value: "", align: "left", sortable: false },
        ];
        if (this.editable) {
            headers.push({ text: "Edit", value: "edit", align: "center", sortable: false });
        }
        return headers;
    }

    get headers_api() {
        if (this.editable) {
            return [
                { text: "Nom de la société", value: "name", align: "left", sortable: false },
                { text: "Siret", value: "siret", sortable: false },
                { text: "Siren", value: "siren", sortable: false },
                { text: "Adresse", value: "address", sortable: false },
                { text: "Code postal", value: "address", sortable: false },
                { text: "Ajouter", value: "edit", sortable: false },
                { text: "", value: "x", sortable: false },
            ];
        }
        return [
            {
                text: "Nom de la société",
                value: "name",
                align: "left",
                sortable: false,
            },
            { text: "Siret", value: "siret", sortable: false },
            { text: "Siren", value: "siren", sortable: false },
            { text: "Adresse", value: "address", sortable: false },
            { text: "Code postal", value: "address", sortable: false },
            { text: "", value: "x", sortable: false },
        ];
    }

    genericLoading_db: boolean = false;

    companiesCount_db: number = 0;

    companiesCount_api: number = 0;

    pagination_db: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: "name",
    };

    pagination_api: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: "name",
    };

    next: boolean = false;

    confirmDeleteDialog: boolean = false;

    companyAddress(company) {
        let companyAddress = company.address || "";
        if (company.postalCode) {
            if (companyAddress) companyAddress += " ";
            companyAddress += company.postalCode;
        }
        if (company.city) {
            if (companyAddress) companyAddress += " ";
            companyAddress += company.city;
        }
        return companyAddress;
    }

    @Apollo(
        {
            query: gql`
                query consumerCompany {
                    companies(where: { type: CONSUMER }) {
                        id
                        name
                        type
                    }
                }
            `,
            skip() {
                return !this.showConsumerCompany || this.activeTab !== "showConsumerCompany";
            },
        },
        (data) => (data && data.companies && data.companies.length ? data.companies[0] : null),
    )
    consumerCompany: any = null;

    get loadingConsumerDb() {
        if (this.$apollo.queries.consumerCompany) {
            return this.$apollo.queries.consumerCompany.loading;
        }
        return false;
    }

    //
    // generic companies
    //

    @Apollo({
        query: GENERIC_COMPANIES,
        variables() {
            return {
                search: this.search,
            };
        },
        skip() {
            return !this.showGenericCompany || this.activeTab !== "showGenericCompany";
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.genericLoading_db = loading;
            if (!loading) {
                if (data && data.companies) {
                    this.genericCompanies = data.companies;
                } else {
                    this.genericCompanies.splice(0, this.genericCompanies.length);
                }
            }
        },
    })
    genericCompanies: Array<any> = [];

    get loadingGenericDb() {
        if (this.$apollo.queries.genericCompanies) {
            return this.$apollo.queries.genericCompanies.loading;
        }
        return false;
    }

    genericCompanyActivity(company) {
        if (
            company.suggestions &&
            company.suggestions.length &&
            company.suggestions[0].purchaseAccount
        ) {
            return (
                company.suggestions[0].purchaseAccount.shortDescription ||
                company.suggestions[0].purchaseAccount.description
            );
        }
        return "";
    }

    //
    // existing companies
    //
    firstQueryCompaniesDB: boolean = true;

    @Apollo({
        query() {
            return this.parentCompanyId ? COMPANIES_FOR_COMPANY_DB : COMPANIES_DB;
        },
        variables() {
            return {
                search: this.search ?? "",
                parentCompany: this.parentCompanyId ? { id: this.parentCompanyId } : undefined,
                type: "NORMAL",
                first: this.pagination_db.rowsPerPage,
                skip: (this.pagination_db.page - 1) * this.pagination_db.rowsPerPage,
            };
        },
        debounce: 500,
        skip() {
            return !this.showExistingCompanies || this.activeTab !== "showExistingCompany";
        },
        specificResult({ data, loading }: any) {
            if (!loading && data) {
                this.firstQueryCompaniesDB = false;

                if (data.companies) {
                    const { companies, companiesConnection } = data;
                    // destructuring : Use the company filter mixin
                    const { activeItems, allItems } = this.prepareCompanies(companies);

                    if (this.infiniteScroll) {
                        this.activeItemsDb.push(...activeItems);
                        this.items_db.push(...allItems);
                    } else {
                        this.activeItemsDb = activeItems;
                        this.items_db = allItems;
                    }

                    this.companiesCount_db = companiesConnection.aggregate.count;
                } else {
                    this.items_db = [];
                    this.activeItemsDb = [];
                    this.companiesCount_db = 0;
                }
            }
        },
    })
    activeItemsDb: Company[] = [];
    items_db: Company[] = [];

    get itemsDb() {
        return this.getFilteredCompanies(this.items_db, this.activeItemsDb, this.showInactive);
    }

    get loadingCompaniesDb() {
        if (this.$apollo.queries.items_db) {
            return this.$apollo.queries.items_db.loading;
        }
        return false;
    }

    sortCustomers(customerCompanies) {
        const favCompany: any = [];
        const notFavCompany: any = [];
        for (const company of customerCompanies) {
            if (company.thirdPartyCompanyData?.isFavorite) {
                favCompany.push(company);
            } else {
                notFavCompany.push(company);
            }
        }
        this.customerCompanies = [...favCompany, ...notFavCompany];
    }

    //
    // customer companies
    //
    @Apollo({
        query: CUSTOMER_COMPANIES,
        fetchPolicy: "network-only",
        variables() {
            return {
                companyId: this.parentCompanyId,
                search: this.search || "",
            };
        },
        debounce: 500,
        skip() {
            return !this.showCustomerCompanies || this.activeTab !== "showCustomerCompany";
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.customerCompanies) {
                        this.sortCustomers(data.customerCompanies);
                    } else {
                        this.customerCompanies = [];
                    }
                }
            }
        },
    })
    customerCompanies: Array<any> = [];

    get customerCompaniesLoading() {
        if (this.$apollo.queries.customerCompanies) {
            return this.$apollo.queries.customerCompanies.loading;
        }
        return false;
    }

    //
    // supplier companies
    //
    @Apollo({
        query: SUPPLIER_COMPANIES,
        variables() {
            return {
                companyId: this.parentCompanyId,
                search: this.search ?? "",
            };
        },
        debounce: 500,
        skip() {
            return !this.showSupplierCompanies || this.activeTab !== "showSupplierCompany";
        },
        specificResult({ data, loading }: any) {
            if (!loading && data?.supplierCompanies) {
                const { supplierCompanies } = data;
                const { activeItems, allItems } = this.prepareCompanies(supplierCompanies);

                const [favCompanies, notFavCompanies] = allItems.reduce(
                    (acc, company) => {
                        acc[company.thirdPartyCompanyData?.isFavorite ? 0 : 1].push(company);
                        return acc;
                    },
                    [[], []],
                );

                this.supplierCompanies = [...favCompanies, ...notFavCompanies];
                this.activeSupplierCompanies = activeItems;

                if (this.infiniteScroll) {
                    this.supplierCompanies.push(...this.supplierCompanies);
                }
            } else {
                this.supplierCompanies = [];
                this.activeSupplierCompanies = [];
            }
        },
    })
    activeSupplierCompanies: Company[] = [];
    supplierCompanies: Company[] = [];

    get filteredSupplierCompanies() {
        return this.getFilteredCompanies(
            this.supplierCompanies,
            this.activeSupplierCompanies,
            this.showInactive,
        );
    }

    get supplierCompaniesLoading() {
        if (this.$apollo.queries.supplierCompanies) {
            return this.$apollo.queries.supplierCompanies.loading;
        }
        return false;
    }

    //
    // bobbee companies
    //
    @Apollo({
        query: BOBBEE_COMPANIES,
        variables() {
            return {
                companyId: this.parentCompanyId,
                search: this.search ?? "",
            };
        },
        debounce: 500,
        skip() {
            return !this.showBobbeeCompanies || this.activeTab !== "showBobbeeCompany";
        },
        specificResult({ data, loading }: any) {
            if (!loading && data?.bobbeeCompanies) {
                const { bobbeeCompanies } = data;
                const { activeItems, allItems } = this.prepareCompanies(bobbeeCompanies);

                if (this.infiniteScroll) {
                    this.activeBobbeeCompanies.push(...activeItems);
                    this.bobbeeCompanies.push(...allItems);
                } else {
                    this.activeBobbeeCompanies = activeItems;
                    this.bobbeeCompanies = allItems;
                }
            } else {
                this.activeBobbeeCompanies = [];
                this.bobbeeCompanies = [];
            }
        },
    })
    activeBobbeeCompanies: Company[] = [];
    bobbeeCompanies: Company[] = [];

    get filteredBobbeeCompanies() {
        return this.getFilteredCompanies(
            this.bobbeeCompanies,
            this.activeBobbeeCompanies,
            this.showInactive,
        );
    }

    get bobbeeCompaniesLoading() {
        if (this.$apollo.queries.bobbeeCompanies) {
            return this.$apollo.queries.bobbeeCompanies.loading;
        }
        return false;
    }

    //
    // orphelin companies
    //
    @Apollo({
        query: ORPHELIN_COMPANIES,
        variables() {
            return {
                companyId: this.parentCompanyId,
                search: this.search ?? "",
            };
        },
        debounce: 500,
        skip() {
            return !this.showOrphelinCompanies || this.activeTab !== "showOrphelinCompany";
        },
        specificResult({ data, loading }: any) {
            if (!loading && data?.orphelinCompanies) {
                const { orphelinCompanies } = data;
                const { activeItems, allItems } = this.prepareCompanies(orphelinCompanies);

                if (this.infiniteScroll) {
                    this.activeOrphelinCompanies.push(...activeItems);
                    this.orphelinCompanies.push(...allItems);
                } else {
                    this.activeOrphelinCompanies = activeItems;
                    this.orphelinCompanies = allItems;
                }
            } else {
                this.activeOrphelinCompanies = [];
                this.orphelinCompanies = [];
            }
        },
    })
    activeOrphelinCompanies: Company[] = [];
    orphelinCompanies: Company[] = [];

    confirmToDeleteOrphelin(company) {
        this.toDeleteCompany.name = company.name;
        this.toDeleteCompany.id = company.id;
        this.confirmDeleteDialog = true;
    }

    async deleteOrphelin(companyIdToDelete) {
        await this.$apollo.mutate({
            mutation: DELETE_COMPANY,
            variables: {
                companyId: companyIdToDelete,
            },
        });
        this.$apollo.queries.orphelinCompanies.refetch();

        this.toDeleteCompany = {
            id: "",
            name: "",
        };
    }

    get filteredOrphelinCompanies() {
        return this.getFilteredCompanies(
            this.orphelinCompanies,
            this.activeOrphelinCompanies,
            this.showInactive,
        );
    }

    get orphelinCompaniesLoading() {
        if (this.$apollo.queries.orphelinCompanies) {
            return this.$apollo.queries.orphelinCompanies.loading;
        }
        return false;
    }

    //
    // new companies
    //

    firstQueryCompaniesApi: boolean = true;

    @Apollo({
        query: COMPANIES_API,
        variables() {
            return {
                search: this.search ?? "",
                first: this.pagination_api.rowsPerPage,
                skip: (this.pagination_api.page - 1) * this.pagination_api.rowsPerPage,
                accountingFirmId: this.accountingFirmId,
                parentCompanyId: this.parentCompanyId,
            };
        },
        debounce: 500,
        skip() {
            return !this.showNewCompanies || this.activeTab !== "showNewCompany" || !this.search;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                this.firstQueryCompaniesApi = false;

                if (data?.companiesDBAndAPI?.companies) {
                    const { companies } = data.companiesDBAndAPI;
                    const { activeItems, allItems } = this.prepareCompanies(companies);

                    if (this.infiniteScroll) {
                        this.activeItemsApi.push(...activeItems);
                        this.items_api.push(...allItems);
                    } else {
                        this.activeItemsApi = activeItems;
                        this.items_api = allItems;
                    }

                    this.updateCompaniesCount(allItems.length);
                } else {
                    this.activeItemsApi = [];
                    this.items_api = [];
                }
            }
        },
    })
    activeItemsApi: any[] = [];
    items_api: any[] = [];

    @Apollo({
        query() {
            return GET_ARCHIVED_COMPANIES;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                accountingFirmId: this.accountingFirmId,
            };
        },
        skip() {
            return !this.showNewCompanies || this.activeTab !== "showNewCompany" || !this.search;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.getArchivingCompanyClientCompanies?.length) {
                    this.archivedClientCompanies = [...data.getArchivingCompanyClientCompanies];
                } else {
                    this.archivedClientCompanies = [];
                }
            }
        },
    })
    archivedClientCompanies = [];

    updateCompaniesCount(newCompaniesCount: number) {
        if (newCompaniesCount < this.pagination_api.rowsPerPage) {
            this.companiesCount_api = Math.max(0, this.companiesCount_api - 1);
        } else if (this.companiesCount_api === 0) {
            this.companiesCount_api = 1;
        }
        this.companiesCount_api += newCompaniesCount;
    }

    get itemsApi() {
        if (this.archivedClientCompanies?.length) {
            const archivedCompanies = this.archivedClientCompanies
                .filter((company) => company.name === this.search)
                .map((company) => {
                    return {
                        id: company.clientId,
                        name: company.name,
                        siret: company.siret,
                        siren: company.siren,
                        archivingDate: company.archivingDate,
                        // Archivé mais pas inactive
                        isActive: true,
                    };
                });

            for (const archivedCompany of archivedCompanies) {
                const existingCompany = this.items_api.find(
                    (company) => company.id === archivedCompany.id,
                );
                if (!existingCompany) {
                    this.items_api.push(archivedCompany);
                }
            }
        }

        const filteredCompanies = this.getFilteredCompanies(
            this.items_api,
            this.activeItemsApi,
            this.showInactive,
        );

        return filteredCompanies;
    }

    get foundCompaniesSirets() {
        const sirets = [];
        if (this.foundCompanies && this.foundCompanies.length) {
            for (const mc of this.foundCompanies) {
                for (const c of mc.companies) {
                    if (c.siret) {
                        sirets.push(c.siret);
                    }
                }
            }
        }
        return sirets;
    }

    //
    // found companies
    //

    @Apollo({
        query: DB_FOUND_COMPANIES,
        variables() {
            return {
                sirets: this.foundCompaniesSirets,
                companyId: this.parentCompanyId,
            };
        },
        debounce: 500,
        skip() {
            return !this.foundCompaniesSirets.length;
        },
        specificResult({ data, loading }: any) {
            if (!loading && data?.companies) {
                const { companies } = data;
                const activeCompanies = companies.filter((company) => company.isActive);
                const inactiveCompanies = companies.filter((company) => !company.isActive);
                this.dbFoundCompanies = [...activeCompanies, ...inactiveCompanies];

                this.updateFoundCompanies();
            } else {
                this.dbFoundCompanies = [];
            }
        },
    })
    dbFoundCompanies: Company[] = [];

    updateFoundCompanies() {
        for (const metaCompany of this.foundCompanies) {
            for (const company of metaCompany.companies) {
                const dbCompany = this.dbFoundCompanies.find((dbc) => dbc.siret === company.siret);
                if (dbCompany) {
                    company.id = dbCompany.id;
                }
            }
        }
    }

    get loadingCompaniesApi() {
        if (this.$apollo.queries.items_api) {
            return this.$apollo.queries.items_api.loading;
        }
        return false;
    }

    get loadingArchivedClientCompanies() {
        if (this.$apollo.queries.archivedClientCompanies) {
            return this.$apollo.queries.archivedClientCompanies.loading;
        }
        return false;
    }

    getFullCompanyName(company) {
        let name = company.name;
        if (company.legalUnitName && company.legalUnitName !== name) {
            name += " (" + company.legalUnitName + ")";
        }
        if (company.tradeName && company.tradeName !== name) {
            name += " (" + company.tradeName + ")";
        }
        return name;
    }

    get thirdPartyCompanyType() {
        return this.dicoActiveTabTPCType[this.activeTab];
    }

    // Toggle show inactive companies
    toggleShowInactive() {
        this.showInactive = !this.showInactive;
    }

    get inactiveCompaniesIcon() {
        return this.showInactive ? "$fa-eye-low-vision" : "$fa-eye";
    }

    get inactiveCompaniesTooltip() {
        return this.showInactive ? "Masquer les sociétés inactives" : "Voir les sociétés inactives";
    }

    get isCompanyArchived() {
        if (this.search) {
            const searchValue = this.search.toLowerCase();

            const archivedCompany = this.archivedClientCompanies.find((company) => {
                const nameMatch = company.name?.toLowerCase() === searchValue;
                const siretMatch = company.siret === this.search;
                return nameMatch || siretMatch;
            });

            return !!archivedCompany;
        }
        return false;
    }

    emit(company: any) {
        // debugger;
        if (this.editable === false) {
            const newVal = {
                id: company.id,
                name: company.name,
                type: company.type,
                legalUnitName: company.legalUnitName,
                tradeName: company.tradeName,
                siret: company.siret,
                siren: company.siren,
                vatNumber: company.vatNumber,
                address: company.address,
                postalCode: company.postalCode,
                country: company.country,
                city: company.city,
                legalForm: company.legalForm,
                legalFormCategory: company.legalFormCategory,
                isActive: company.isActive,
                activities: company.activities,
                parentCompany: company.parentCompany,
                parentCompanyId: company.parentCompanyId ? company.parentCompanyId : undefined,
                thirdPartyCompanyType: this.thirdPartyCompanyType,
            };
            this.value = newVal;
            // console.log("emit", newVal, this.value);
            this.$emit("select-company", newVal);
        }
    }

    onAdd(item) {
        // debugger;
        if (this.editable === true) {
            if (item.id) {
                this.$router.push({ name: `companies-edition`, params: { id: item.id } });
            } else {
                this.$router.push({
                    name: "create-company",
                    params: {
                        nameCompany: item.name,
                        siret: item.siret,
                        siren: item.siren,
                        vatNumber: item.vatNumber,
                        address: item.address,
                        postalCode: item.postalCode,
                        country: item.country,
                        city: item.city,
                        legalForm: item.legalForm,
                        legalFormCategory: item.legalFormCategory,
                        isActive: item.isActive,
                        activities: item.activities,
                        type: item.type,
                    },
                });
            }
        }
        this.emit(item);
    }

    onEdit(item) {
        if (this.editable === true) {
            this.$router.push({ name: `companies-edition`, params: { id: item.id } });
        }
        this.emit(item);
    }

    companiesToMerge(companyId) {
        const isSelected = this.isSelectedCompany(companyId);
        if (isSelected) {
            this.selectedCompanies = this.selectedCompanies.filter((c) => c.id !== companyId);
        } else {
            this.selectedCompanies.push({ id: companyId });
        }
        this.$emit("companies-to-merge", this.selectedCompanies);
    }

    isSelectedCompany(companyId) {
        const isSelected = this.selectedCompanies.find((c) => c.id === companyId);
        return isSelected;
    }

    createNewMissingCompany() {
        const parentCompanyId = this.parentCompanyId;
        if (parentCompanyId || this.accountingFirmId) {
            if (this.editable) {
                this.$router.push({
                    name: "create-company",
                    params: { nameCompany: this.search, parentCompanyId },
                });
            }
            this.emit({ name: this.search, parentCompanyId });
            // console.log("search : ", {name: this.search, parentCompanyId})
        } else {
            debugger;
        }
    }

    // Erwann replace by any because archivedCompanies have a special payload return
    isSelectable(company: any) {
        if (!company.isActive) {
            return this.canSelectInactiveCompanies;
        }
        if (company.archivingDate) {
            return false;
        }
        if (company.isClientOfAccountingFirm) {
            return this.canSelectCompaniesWithAccountingCompany;
        }
        return true;
    }

    paginationAPIIntersecting(_, entries, observer) {
        if (!this.firstQueryCompaniesApi) {
            this.pagination_api.page++;
        }
    }

    paginationDBIntersecting(_, entries, observer) {
        if (!this.firstQueryCompaniesDB) {
            this.pagination_db.page++;
        }
    }

    // @Watch('selectedCompanies', { deep: true})
    // watchSelectedCompanies() {
    //     debugger
    //     this.selectedCompanies
    // }

    //
    // reset
    //
    @Watch("activeTab")
    @Watch("search")
    resetList() {
        this.genericCompanies = [];
        this.supplierCompanies = [];
        this.activeSupplierCompanies = [];
        this.customerCompanies = [];
        this.orphelinCompanies = [];
        this.activeOrphelinCompanies = [];
        this.bobbeeCompanies = [];
        this.activeBobbeeCompanies = [];
        //
        this.items_db = [];
        this.activeItemsDb = [];
        this.items_api = [];
        this.activeItemsApi = [];
        //
        this.pagination_db.page = 1;
        this.pagination_api.page = 1;
        //
        this.firstQueryCompaniesApi = true;
        this.firstQueryCompaniesDB = true;
        //
        this.companiesCount_api = 0;
    }

    emptyMergingList() {
        this.$emit("disable-merge-button", true);
        this.selectedCompanies = [];
    }

    importCompanies() {
        this.$emit("import-companies", true);
        this.selectedCompanies = [];
    }

    getSiretValue(siret) {
        return getSiretValue(siret);
    }

    getArchivingDate(date: string) {
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
    }

    selectAllCompany(companies) {
        for (const company of companies) {
            const isSelected = this.isSelectedCompany(company.id);
            if (isSelected) {
                this.selectedCompanies = this.selectedCompanies.filter((c) => c.id !== company.id);
            } else {
                this.selectedCompanies.push({ id: company.id });
            }
            this.$emit("companies-to-merge", this.selectedCompanies);
        }
    }

    diselectAllCompany() {
        this.$emit("disable-merge-button", true);
        this.selectedCompanies = [];
    }

    // @Watch("selectedCompanies", {deep: true})
    // onSelectedCompaniesChanged() {
    //     debugger
    //     this.$emit("orphelin-companies", (this.selectedCompanies || []))
    // }

    // @Watch("activeTab")
    // onActiveTabChanged() {
    //     console.log(this.activeTab)
    //     this.$emit("delete-button", this.activeTab)
    // }

    focusOnFirstSupplier() {
        if (this.showSupplierCompanies && this.supplierCompanies.length) {
            const firstSupplier = document.querySelector(
                `[data-cy="CompaniesTable-${this.supplierCompanies[0].siret}"]`,
            ) as HTMLElement;
            if (firstSupplier) {
                setTimeout(() => firstSupplier.focus(), 1);
            }
        }
    }

    refreshOrphelinCompanies() {
        this.$apollo.queries.orphelinCompanies.refetch();
        this.$apollo.queries.companies.refetch();
    }

    async deleteOrphelinCompanies() {
        if (this.selectedCompanies && this.selectedCompanies.length) {
            try {
                const deletedOrphelinCompanies = await this.$apollo.mutate({
                    mutation: DELETE_ORPHELIN_COMPANIES,
                    variables: {
                        companyIds: this.selectedCompanies.map((c) => c.id),
                    },
                });

                if (deletedOrphelinCompanies) {
                    this.selectedCompanies = [];
                    this.$apollo.queries.orphelinCompanies.refetch();
                    this.multiDeleteDialog = false;
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    @Watch("activeTab")
    setActions() {
        // debugger
        if (this.activeTab === "showOrphelinCompany") {
            this.actions.action.function = () => {
                this.multiDeleteDialog = true;
            };
            this.actions.action.title = "Supprimer";
            // Vous pouvez également conditionnellement désactiver le bouton de suppression si nécessaire.
            this.actions.action.disabled = () => {
                return !this.selectedCompanies.length;
            };
        } else {
            this.$emit("emit-actions", "");
        }
    }
}

export default toNative(CompaniesTable);
</script>

<style></style>
